import TcVod from 'vod-js-sdk-v6'
import axios from 'axios'
import { Controller } from '@hotwired/stimulus'
function getSignature() {
  return document.getElementById("sign").dataset["sign"]
}

function getVideoPlayerInfo(file) {
  return new Promise(resolve => {
    const videoElement = document.createElement('video');
    videoElement.src = URL.createObjectURL(file);
    videoElement.addEventListener('loadedmetadata', function() {
      resolve({
        duration: videoElement.duration,
        width: videoElement.videoWidth,
        height: videoElement.videoHeight
      });
    });
  });
}
export default class extends Controller {
  static values = {
    signature: String
  }
  static targets = ['file', "fileId", "fileName", "fileType", "fileSize", "progress", "duration", "width", "height"]
  connect() {
    console.log("connect", this.signatureValue)
    const self = this
    this.tcVod = new TcVod({
      getSignature: self.getSignature.bind(this)
    })
    this.uploaderInfo = {}
  }

  async change() {
    const file = this.fileTarget.files[0]
    console.log(file.size, file.name, file.type)
    if (file.size > 100 * 1024 * 1024) {
      alert("文件不能大于100M")
      this.fileTarget.value = ""
      return
    }

    // 检查分辨率
    const { duration, width, height } = await getVideoPlayerInfo(file)
  
    console.log(duration, width, height)
    if (height < 720 || width < 720) {
      alert("视频分辨率太低，最低要求720p")
      this.fileTarget.value = ""
      return
    } 

    this.durationTarget.value = Math.round(duration)
    this.widthTarget.value = width
    this.heightTarget.value = height

    
    console.log("statt====")

    this.fileNameTarget.value = file.name
    this.fileTypeTarget.value = file.type
    this.fileSizeTarget.value = file.size
    console.log("change", this.signatureValue)
  }
  upload() {

    console.log("upload")

    const self = this

    const file = self.fileTarget.files[0]
    console.log(file.size, file.name, file.type,  self.progressTarget.value)

    // self.fileNameTarget.value = file.name
    // self.fileTypeTarget.value = file.type
    // self.fileSizeTarget.value = file.size
    const uploader = this.tcVod.upload({
      mediaFile: file, // 媒体文件（视频或音频或图片），类型为 File
    })

    var uploaderInfo = {
      videoInfo: uploader.videoInfo,
      isVideoUploadSuccess: false,
      isVideoUploadCancel: false,
      progress: 0,
      fileId: '',
      videoUrl: '',
      cancel: function() {
        uploaderInfo.isVideoUploadCancel = true;
        uploader.cancel()
      },
    }

    uploader.on('media_progress', function(info) {
      console.log(info.percent) // 进度
      uploaderInfo.progress = info.percent
      self.progressTarget.value = info.percent * 100
    })

    uploader.on('media_upload', function (info) {
      uploaderInfo.isVideoUploadSuccess = true;
    })

    console.log(uploader, 'uploader')




    uploader.done().then(function(doneResult) {
      console.log('doneResult', doneResult)

      uploaderInfo.fileId = doneResult.fileId;

      self.fileIdTarget.value = doneResult.fileId
      // return getAntiLeechUrl(doneResult.video.url);
      return doneResult.fileId
    }).then(function (fileId) {
      // uploaderInfo.videoUrl = videoUrl
      // self.$refs.vExample.reset();
      console.log(fileId, "fileId")
      // document.getElementById("result").innerHTML = JSON.stringify(uploaderInfo)
    })

    this.uploaderInfo = uploaderInfo

  }

  getSignature() {
    console.log("start", this.signatureValue, this)
    return this.signatureValue
  }
}
